import { Lotacao } from './lotacao.model';
import { Usuario } from './usuario.model';
import { Perfil } from './perfil.model';
import { Status } from './status.model';
import { Anexo } from './anexo-usuario-lotacao.model';

export class MinhasPermissoes {
    public id: number;
    public id_usuario: number;
    public id_lotacao: number;
    public id_perfil: number;
    public id_status: number;
    public justificativa_solicitacao: string;
    public justificativa_validacao: string;
    public data_expiracao: Date;
    public data_exclusao_unidades: Date;
    public excluido_por: number;

    public lotacao: Lotacao;
    public usuario: Usuario;
    public perfil: Perfil;
    public status: Status;
    public anexo: Anexo[];
}


// WEBPACK FOOTER //
// ./src/app/entity/minhas-permissoes.model.ts